// Shared address formatting utilities
// Ensures we don't duplicate city/state/zip when street already contains them

// #6217: "already contains" means as a whole word. A substring test dropped the state OR from
// "1234 SE Hawthorne Blvd" (hawthORne) or "9 Orchard Way". A city that is a whole word of the
// street ("100 Portland Ave") is still treated as already present.
const containsWord = (haystack, needle) => {
  if (!needle) return false;
  const escaped = needle.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`(^|[^a-z0-9])${escaped}([^a-z0-9]|$)`).test(haystack.toLowerCase());
};

export function formatAddressSafe(obj = {}) {
  const street = (obj.street_address || obj.address_line_1 || '').trim();
  // #6217: the unit line (customer_addresses.address_line_2) was never printed, so two
  // apartments at one street read the same.
  const unit = (obj.address_line_2 || '').trim();
  const city = (obj.city || obj.billing_city || '').trim();
  const state = (obj.state || obj.billing_state || '').trim();
  const zip = (obj.postal_code || obj.zip_code || obj.billing_zip_code || '').trim();

  if (!street && !city && !state && !zip) return '';

  const parts = [];
  if (street) parts.push(street);
  if (unit && !containsWord(street, unit)) parts.push(unit);
  if (city && !containsWord(street, city)) parts.push(city);
  if (state && !containsWord(street, state)) parts.push(state);
  if (zip && !street.includes(zip)) parts.push(zip);
  return parts.filter(Boolean).join(', ');
}

// Optional: return two display lines [line1, line2] for UIs that want split
export function splitAddressLines(obj = {}) {
  const street = (obj.street_address || obj.address_line_1 || '').trim();
  const city = (obj.city || obj.billing_city || '').trim();
  const state = (obj.state || obj.billing_state || '').trim();
  const zip = (obj.postal_code || obj.zip_code || obj.billing_zip_code || '').trim();

  const secondLine = [city, state, zip].filter(Boolean).join(', ');
  const showSecond = Boolean(secondLine) && !(
    (city && containsWord(street, city)) ||
    (state && containsWord(street, state)) ||
    (zip && street.includes(zip))
  );

  return [street, showSecond ? secondLine : ''];
}

